import { lazy } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { ErrorBoundary } from '@platform/client/components/error-boundaries/error-boundary';
import { ErrorBoundarySadWolf } from '@platform/client/components/error-boundaries/error-boundary-sad-wolf';

import { CmsApiProvider } from '@apis/credential-management-service/cms-api-provider';
import { SoarApiProvider } from '@apis/soar-active-response/soar-api-provider';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import {
  ACCOUNT_ITSM_INTEGRATIONS_ROUTE,
  ACTIVE_RESPONSE,
} from 'ae-constants/routes.constants';

import { ActiveResponseRoutes } from '../active-response';
import { ItsmIntegrationsRoutes } from '../itsm-integrations';

const IntegrationsTabListLayoutPage = lazy(
  () => import('./integrations-tab-list-layout.page'),
);

const ActiveResponsePage = lazy(
  () => import('../active-response/active-response.page'),
);

const ItsmIntegrationsPage = lazy(
  () => import('../itsm-integrations/itsm-integrations/itsm-integrations.page'),
);

export const IntegrationsRoutes = () => {
  const [activeRespFF] = useFeatureFlag('ACTIVE_RESPONSE');

  const indexRoute = [
    activeRespFF && ACTIVE_RESPONSE,
    ACCOUNT_ITSM_INTEGRATIONS_ROUTE,
  ]
    .filter((p) => p)
    .at(0);

  if (!indexRoute) {
    return null;
  }

  return (
    <Routes>
      <Route index element={<Navigate to={indexRoute} replace />} />
      <Route element={<IntegrationsTabListLayoutPage />}>
        {activeRespFF && (
          <Route
            path="active-response"
            element={
              <ErrorBoundarySadWolf>
                <SoarApiProvider>
                  <CmsApiProvider>
                    <ActiveResponsePage />
                  </CmsApiProvider>
                </SoarApiProvider>
              </ErrorBoundarySadWolf>
            }
          />
        )}

        <Route
          path="itsm"
          element={
            <ErrorBoundary>
              <ItsmIntegrationsPage />
            </ErrorBoundary>
          }
        />
      </Route>
      {activeRespFF && (
        <Route path="active-response/*" element={<ActiveResponseRoutes />} />
      )}
      <Route path="itsm/*" element={<ItsmIntegrationsRoutes />} />
    </Routes>
  );
};
